module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Отказ"
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Запис"
    },
    on: {
      "click": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  })])])])])]), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('f-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "link_title",
      "errors": _vm.errorBag.collect('link_title')
    },
    model: {
      value: (_vm.link.title),
      callback: function($$v) {
        _vm.$set(_vm.link, "title", $$v)
      },
      expression: "link.title"
    }
  }), _vm._v(" "), _c('f-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "link_description",
      "errors": _vm.errorBag.collect('link_description')
    },
    model: {
      value: (_vm.link.description),
      callback: function($$v) {
        _vm.$set(_vm.link, "description", $$v)
      },
      expression: "link.description"
    }
  }), _vm._v(" "), _c('f-category', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "link_categories",
      "errors": _vm.errorBag.collect('link_categories')
    },
    model: {
      value: (_vm.link.categories),
      callback: function($$v) {
        _vm.$set(_vm.link, "categories", $$v)
      },
      expression: "link.categories"
    }
  }), _vm._v(" "), _c('f-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "link_language",
      "errors": _vm.errorBag.collect('link_language'),
      "values": _vm.$config.lists.languages
    },
    model: {
      value: (_vm.link.language),
      callback: function($$v) {
        _vm.$set(_vm.link, "language", $$v)
      },
      expression: "link.language"
    }
  }), _vm._v(" "), _c('f-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "link_link",
      "errors": _vm.errorBag.collect('link_link')
    },
    model: {
      value: (_vm.link.link),
      callback: function($$v) {
        _vm.$set(_vm.link, "link", $$v)
      },
      expression: "link.link"
    }
  })], 1)])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6ca92d11!./~/vue-loader/lib/selector.js?type=template&index=0!./~/htmlhint-loader?{"configFile":".htmlhintrc.json","failOnError":true}!./src/components/share/LinkResourceEdit.vue
// module id = 661
// module chunks = 1